import _ from 'lodash';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import React, {
    useCallback,
    useContext,
    useEffect,
    useState,
    useMemo
} from 'react';
import messages from './GroupSummary.messages';
import metadata from './GroupSummary.metadata.json5';
import styles from './GroupSummary.module.scss';
import AddAgency from '../../components/AddAgency/AddAgency';
import { ServiceManager } from '@jutro/legacy/services';
import { PhoneUtil } from '@xengage/gw-portals-viewmodel-js';
import { Link } from '@jutro/router';
function GroupSummary(props) {
    const { userVM, getAdministrators, editAgencyInfo,getAddAgencyContent } = props;
    const [producerGroupSummary, setProducerGroupSummary] = useState(userVM.producerGroupsSummary_EXT.value);
    const [searchVal, setSearchValue] = useState('');

    const filterProducerSummary = (groupSummary, searchParam) => {
        const prodSummary = _.filter(groupSummary, (sum) => !sum.isMasterGroup);
        
        if (_.isEmpty(searchParam)) {
            return prodSummary;
        }

        return _.filter(prodSummary, (summary) =>
            ((summary.name && _.includes(summary.name.toLocaleLowerCase(),
                searchParam.toLocaleLowerCase()))
                || (summary.producerCode && _.includes(summary.producerCode.toLocaleLowerCase(),
                    searchParam.toLocaleLowerCase()))
                || (summary.primaryContactName && _.includes(summary.primaryContactName.toLocaleLowerCase()
                    , searchParam.toLocaleLowerCase()))
                || (summary.email && _.includes(summary.email.toLocaleLowerCase()
                    , searchParam.toLocaleLowerCase()))
                || (summary.phoneNumber && _.includes(summary.phoneNumber.toLocaleLowerCase()
                    , searchParam.toLocaleLowerCase()))
                || (summary.status && _.includes(summary.status.toLocaleLowerCase()
                    , searchParam.toLocaleLowerCase()))
            ));
    };

    const handleSearchValueChange = useCallback(keyword => {
        setSearchValue(keyword);
    }, [setSearchValue]);

    const getOrganizationAdmins = useCallback(() => {
        getAdministrators();
    }, [getAdministrators]);

    const getNameLink = useCallback((item) => (  
             
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
       
        <Link onClick={() => {editAgencyInfo(item);  getAddAgencyContent(false)}}>
            {item.row.name}
        </Link>
        
    ), [editAgencyInfo]);

    const onAddAgency=()=>{
       
        const { history } = props;
        // history.push('/administration/addAgency');
        getAddAgencyContent(true);

    }

    /** DE15332 format phone number */
    const getPhoneNumber = item => {  
        const phoneNumber = _.get(item, 'row.phoneNumber');
        const phoneUtil = PhoneUtil();
        const countryCode = ServiceManager.getService('locale-service').getDefaultCountryCode();
        const pretty = phoneNumber ? phoneUtil.prettyPrint(phoneNumber, countryCode) : '-';
        return (<span>{pretty}</span>);
    };

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            phoneWide: {
                labelPosition: 'top',
            },
        },
        groupSummaryList: {
            data: filterProducerSummary(producerGroupSummary, searchVal)
        },
        searchAgencies: {
            searchValue: searchVal,
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            // addressSummaryComponent: AddressSummary              
        },
        resolveCallbackMap: {
            searchChangeFn: handleSearchValueChange,
            getNameLink,
            getPhoneNumber,
            getOrganizationAdmins,
            onAddAgency
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={userVM}
            overrideProps={overrideProps}
            // onValueChange={handleSearchValueChange}
            classNameMap={resolvers.resolveClassNameMap}
            callbackMap={resolvers.resolveCallbackMap}
        />
    );
}

GroupSummary.propTypes = {

};

GroupSummary.defaultProps = {

};

export default GroupSummary;
